import { Component } from '@angular/core';
import { CertifiedLocationBaseComponent } from '../certified-location-base.component';
import { GenericForm, LocationTypes, ZnHierarchicalViewComponent } from '@zendra/shared';
import { ListService } from '@abp/ng.core';
import { WoodCertificationDetailService } from 'geographic/proxy';
import { WoodCertificationDetailPlanningOrchestratorService } from 'orchestrator';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { CERTIFIEDTHIRDPARTYPROPERTY_CONFIG, CERTIFIEDTHIRDPARTYPROPERTY_FIELDS } from './certified-third-party-property.config';

@Component({
  selector: 'lib-certified-third-party-property',
  imports: [GenericForm, ZnHierarchicalViewComponent],
  providers: [
    ListService,
    WoodCertificationDetailService,
    WoodCertificationDetailPlanningOrchestratorService,
    ConfirmationService,
  ],
  templateUrl: './certified-third-party-property.html',
})
export class CertifiedThirdPartyProperty extends CertifiedLocationBaseComponent {
  config = CERTIFIEDTHIRDPARTYPROPERTY_CONFIG;
  fields = CERTIFIEDTHIRDPARTYPROPERTY_FIELDS;

  protected getWoodCertificationType(): LocationTypes {
    return LocationTypes.ThirdPartyProperty;
  }

  protected getEntityName(): string {
    return 'CertifiedThirdPartyProperty';
  }
}
